import { SigningServiceHttp } from '../signing-service';
import { Injectable } from "@angular/core";
@Injectable({
    providedIn: 'root'
})

export class SignatureBoxService {
    constructor(private http: SigningServiceHttp) {
        
    }
    
    /**
     * upload the recipient signature
     * @param signature 
     * @param roleId 
     */
    saveSignature(signature:string, roleId:number, isEform:boolean = false, roleable_id:number){
        const apiRoute = isEform ? `eform-signing/${roleId}/${roleable_id}` : `sign-document/${roleId}`;
       return this.http.post(`${apiRoute}/signature`,{signature:signature});
    }

}